var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M10 20L10 14 14 14 14 20 19 20 19 12 22 12 12 3 2 12 5 12 5 20z","transform":"translate(4 4)","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","transform":"translate(4 4)","key":1})]));
}

Home.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Home;

Home.default = Home;
